/**
 * SeloChegando — o selo amarelo "🛒 Chegando + data" do produto com compra em aberto (DA-368).
 *
 * Peca unica da lista de Produtos (coluna Estoque) e do Mais Vendidos (a direita da descricao): o mesmo selo nas duas telas
 * (pedido do Ruan, 29/10/2026 — e a palavra trocou de "Comprado" pra "Chegando", "assim vai ajudar a
 * lembrar do que se trata"). Com `onEditar`, vira botao que abre o EditorDataCompra (a data so se
 * corrige por aqui — a coluna Ult. Compra e' so-leitura); sem, e' so o selo.
 */
import type { MouseEvent } from 'react';
import { formatDataSP } from '@fiodecobre/shared';

/** " · qtd 3 CX" — sem embalagem gravada (marca anterior a 29/10/2026), so o numero. */
export function textoQtdComprada(qtd: string | number | null | undefined, emb: string | null | undefined): string {
  if (!qtd) return '';
  return ` · qtd ${Number(qtd).toLocaleString('pt-BR', { maximumFractionDigits: 3 })}${emb ? ` ${emb}` : ''}`;
}

export function SeloChegando({
  dataISO,
  fornecedorNome,
  qtd,
  emb,
  onEditar,
}: {
  dataISO: string | null;
  fornecedorNome: string | null;
  qtd: string | number | null;
  /** A embalagem da qtd (CX, UN) — a qtd e' o Tot Emb da cotacao, em embalagens (DA-864). */
  emb?: string | null;
  onEditar?: (rect: DOMRect) => void;
}) {
  const title = `Comprado ${dataISO ? formatDataSP(dataISO) : ''}${fornecedorNome ? ` · ${fornecedorNome}` : ''}${textoQtdComprada(qtd, emb)}${onEditar ? ' — clique para ajustar a data' : ''}`;
  const style = { display: 'inline-flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.15, marginLeft: 6, backgroundColor: '#fde68a', color: '#000', padding: '2px 8px', borderRadius: 12, fontSize: '12px', fontWeight: 700, verticalAlign: 'middle', border: 'none', cursor: onEditar ? 'pointer' : 'default', whiteSpace: 'nowrap' } as const;
  const conteudo = (
    <>
      <span>🛒 Chegando</span>
      {dataISO && <span>{formatDataSP(dataISO)}</span>}
    </>
  );

  if (!onEditar) return <span title={title} style={style}>{conteudo}</span>;
  return (
    <button
      type="button"
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onEditar(e.currentTarget.getBoundingClientRect());
      }}
      onDoubleClick={(e) => e.stopPropagation()}
      title={title}
      style={style}
    >
      {conteudo}
    </button>
  );
}
